import { apiAuth, apiResponseType } from "./index";

export interface BleedFilters {
  code?: string;
  seller_id?: number[];
  bleed_status_id?: string;
  start_date?: string;
  end_date?: string;
  order_by?: "bleed_date" | "code" | "value" | "created_at" | "seller_name";
  order_direction?: "asc" | "desc";
  per_page?: number;
}

export const getBleeds = (page = 1, filters: BleedFilters = {}) => {
  const params = new URLSearchParams({ page: String(page) });

  if (filters.code) params.append("code", filters.code);
  filters.seller_id?.forEach((id) => params.append("seller_id[]", String(id)));
  if (filters.bleed_status_id) params.append("bleed_status_id", filters.bleed_status_id);
  if (filters.start_date) params.append("start_date", filters.start_date);
  if (filters.end_date) params.append("end_date", filters.end_date);
  if (filters.order_by) params.append("order_by", filters.order_by);
  if (filters.order_direction) params.append("order_direction", filters.order_direction);
  if (filters.per_page) params.append("per_page", String(filters.per_page));

  return apiAuth.get(`bleeds?${params.toString()}`) as apiResponseType;
};

export const createBleed = (data: {
  code: string;
  bleed_date: string;
  value: number;
  observation?: string;
  seller_id?: number;
  files: File[];
}) => {
  const formData = new FormData();
  formData.append("code", data.code);
  formData.append("bleed_date", data.bleed_date);
  formData.append("value", String(data.value));
  if (data.observation) formData.append("observation", data.observation);
  if (data.seller_id) formData.append("seller_id", String(data.seller_id));
  data.files.forEach((file) => formData.append("files[]", file));

  return apiAuth.post("bleeds/store", formData) as apiResponseType;
};

export const getShowBleed = (uuid: string) =>
  apiAuth.get(`bleeds/${uuid}/show`) as apiResponseType;

export const approveBleed = (uuid: string, observation?: string) =>
  apiAuth.put(`bleeds/${uuid}/approve`, { observation }) as apiResponseType;

export const rejectBleed = (uuid: string, observation?: string) =>
  apiAuth.put(`bleeds/${uuid}/reject`, { observation }) as apiResponseType;

/**
 * Saldo de sangria do vendedor (sem seller_id: vendedor logado).
 * has_bleed indica se a unidade do vendedor usa sangria.
 */
export const getBleedBalance = (sellerId?: number) =>
  apiAuth.get(`bleeds/balance${sellerId ? `?seller_id=${sellerId}` : ""}`) as apiResponseType;
